import React, { useState, useEffect } from 'react';
import { Container } from './styles';
import { DecreaseIcon, IncreaseIcon } from 'assets/icons';
import { dateDiff } from 'utils/util';

const EditBar = ({
  value,
  setValue,
  length,
  setLength,
  checkInDate,
  checkOutDate,
  unit,
  pluralUnit,
  unitPrice,
  title,
  additionalstyle,
}) => {

  const [maxLength, setMaxLength] = useState(14)

  useEffect(()=>{
    if(checkInDate && checkOutDate) {
      const length = dateDiff(checkInDate, checkOutDate)
      setMaxLength(length)
    }
  },[checkInDate, checkOutDate])

  return (
    <Container
      additionalstyle={additionalstyle}
    >
      {title && <div className='label'>
        {title}
      </div>}
      <div className='info'>
        <div>
          <span
            className={'decrease' + (value<1? ' disabled':'')}
            onClick={()=> {
              if(value >= 1) {
                setValue(value - 1);
              }
            }}
          >
            <DecreaseIcon />
          </span>
          <span className='value'>{value + " " + (value>1? pluralUnit :unit)}</span>
          <span
            className={'increase'}
            onClick={()=> {
              setValue(value + 1)
            }}
          >
            <IncreaseIcon />
          </span>
          <span className='for'> For </span>
          <span
            className={'decrease' + (length<2? ' disabled':'')}
            onClick={()=> {
              if(length >= 2) {
                setLength(length - 1);
              }
            }}
          >
            <DecreaseIcon />
          </span>
          <span className='value'>{length + " " + (length>1? 'Nights' :'Night')}</span>
          <span
            className={'increase' + (length >= maxLength? ' disabled':'')}
            onClick={()=> {
              if(length < maxLength)
              setLength(length + 1)
            }}
          >
            <IncreaseIcon />
          </span>
        </div>
        <div>
          <span className='description'>{`$${unitPrice} / ${unit} @ ${length} ${length > 1? 'Nights': 'Night'} = $${(unitPrice * value * length).toFixed(2)}`}</span>
        </div>
      </div>
    </Container>
  );
}

export default EditBar;